module.exports = __webpack_public_path__ + "img/service-icon.fc570ae1.svg";